// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__1BS0M","fileDisabled":"File_fileDisabled__3bOc5"};